import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'utils/components/modal';

import RadioButtonsInput from '../radio-buttons-input';
import ModalAvatarsStyle from '../../../modals/avatars-style';

var AvatarsStyleKeys = {
  COLORFUL: { value: 'colorful', text: 'Colorful' },
  GREY: { value: 'gray', text: 'Grey' }
};

class AvatarsStyle extends Component {
  avatarStyleChange(value) {
    const scheme = value;

    this.props.editSpot({ scheme });
    this.closeModal();
  }

  openModal() {
    this.refs.modalAvatarsStyle.show();
  }

  closeModal() {
    this.refs.modalAvatarsStyle.hide();
  }

  render() {
    if (!this.props.value) {
      return null;
    }

    const { scheme } = this.props.value;

    return (
      <div className="newsfeed-position-selection">
        <RadioButtonsInput
          name="newsfeed-launcher-position"
          className="newsfeed-launcher-position"
          title="Avatars Style"
          description="Choose the scheme of user avatars which best fits your site."
          onChange={this.avatarStyleChange.bind(this)}
          options={[AvatarsStyleKeys.COLORFUL, AvatarsStyleKeys.GREY]}
          learnMore={this.openModal.bind(this)}
          isTextBold
          value={scheme}
        />
        <Modal ref="modalAvatarsStyle" className="avatars-style">
          <ModalAvatarsStyle
            onChange={this.avatarStyleChange.bind(this)}
            selected={scheme}
            onClose={this.closeModal.bind(this)}
          />
        </Modal>
      </div>
    );
  }
}

AvatarsStyle.propTypes = {
  value: PropTypes.object
};

AvatarsStyle.displayName = 'AvatarsStyle';

export default AvatarsStyle;
